function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copy_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3346 10.7503V14.2503C13.3346 17.167 12.168 18.3337 9.2513 18.3337H5.7513C2.83464 18.3337 1.66797 17.167 1.66797 14.2503V10.7503C1.66797 7.83366 2.83464 6.66699 5.7513 6.66699H9.2513C12.168 6.66699 13.3346 7.83366 13.3346 10.7503Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.3346 5.75033V9.25033C18.3346 12.167 17.168 13.3337 14.2513 13.3337H13.3346V10.7503C13.3346 7.83366 12.168 6.66699 9.2513 6.66699H6.66797V5.75033C6.66797 2.83366 7.83464 1.66699 10.7513 1.66699H14.2513C17.168 1.66699 18.3346 2.83366 18.3346 5.75033Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3fa604f98cea560b80e40373ce3e55d8.svg";
export { ForwardRef as ReactComponent };